/**
 * 28 spec Radius トークン
 *
 * 一次情報: hub/log/28.../03_ui_implementation_spec.md §1.3
 */
export const RADIUS = {
  none: 0,
  sm: 4,
  md: 6,
  lg: 8,
  xl: 12,
  full: 9999,
} as const
